import glamorous from 'glamorous';
import themes from "../../themes"


 const BookThumbStyled = glamorous.div({
        color: "black",
        display: "flex",
        height: "100px", 
        width:"700px", 
        padding: "18px",
        ':hover': {
            opacity: 0.6,
            boxShadow: "1px 1px 2px rgba(1,1,1, .8)",
        },
        ':focus': { outline: 0 }
    
},
props => {
  switch (props.theme) {
    case "dark": {
      return { backgroundColor: themes[0].color1, color: themes[0].text, outline: `1px solid ${themes[0].text}` } 
    }
    case "light": {
      return { backgroundColor: themes[1].color1, color: themes[1].text, outline: `1px solid ${themes[1].text}`}
    }
  }
}
);

export default BookThumbStyled


// WEBPACK FOOTER //
// ./src/containers/booklist/BookThumbStyled.js